import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { InputSize } from '../../enum/input-size.enum';

@Component({
  selector: 'lib-radio-button',
  imports: [],
  templateUrl: './radio-button.component.html',
  styleUrl: './radio-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonComponent {
  selected = input<boolean>(false);
  disabled = input<boolean>(false);
  size = input<InputSize>(InputSize.large);
  buttonClick = output<void>();
  protected readonly InputSize = InputSize;
}
